// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/icons/flip-arrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-profile-header-wrap {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 20px;
}

.inhouse-main-wrap {
    width: 233px;
    height: 70px;
    background: #F8F8F8;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

.inhouse-main-wrap p{
    font-size: 22px;
    color: #00A19B;
    font-weight: 400;
    margin: 0px;
}

.account-edit-profile-right{
    display: flex;
    align-items: flex-end;
    gap: 24px;
}

.profile-edit-application-dropdown .select-box-wrapper label {
    font-size: 28px;
    color: #1A1919;
    font-weight: 600;
    padding-left: 30px;
    margin: 0px;
    padding-bottom: 6px;
}


.profile-edit-application-dropdown .react-dropdown .react-dropdown-btn{
    width: 233px;
    height: 70px;
}

.profile-edit-application-dropdown .react-dropdown .dropdown-content {
    width: 240px;
}

.profile-edit-application-dropdown .react-dropdown .dropdown-content .dropdown-item {
    width: 220px;
}


.inhouse-main-wrapper .disable-twofa-input-wrap label {
    cursor: pointer;
    text-indent: -9999px;
    width: 40px;
    height: 20px;
    background: #dff0f1;
    
    display: block;
    border-radius: 100px;
    position: relative;
}

.inhouse-main-wrapper .disable-twofa-input-wrap label:after {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 14px;
    height: 14px;
    background: #BFBFBF;
    border-radius: 90px;
    transition: 0.3s;
}


.inhouse-main-wrapper .disable-twofa-input-wrap input:checked + label:after {
    left: calc(100% - 4px);
    transform: translateX(-100%);
    background: #00A19B !important;
}

.inhouse-main-wrapper .disable-twofa-input-wrap {
    margin-top: 6px;
}

.edit-profile-address-wrapper{
    margin-top: 40px;
}

.edit-profile-address-wrap {
    width: 100%;
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 18px;
}

.edit-profile-address-left{
    width: 100%;
    min-height: 510px;
    border: 2px solid #F8F8F8;
    border-radius: 34px;
    padding: 40px;
}

.edit-profile-main-left-wrap{
    padding: 40px 55px;
}


.edit-profile-address-left h4 {
    font-size: 24px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.edit-address-repeat {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
}

.edit-address-left p {
    font-size: 20px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px;
}

.edit-address-right p {
    font-size: 20px;
    color: #626262;
    font-weight: 500;
    margin: 0px;
}


.city-services-select-wrap {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    margin-top: 30px;
    margin-bottom: 10px;
}

.city-services-select-wrap .checkbox-container {
    padding-left: 36px;
    margin-bottom: 30px;
    white-space: nowrap;
}

.city-services-select-wrap .checkbox-container .checkmark {
    height: 22px;
    width: 22px;
}


.contractor-certificate-wrap {
    width: 50%;
    display: grid;
    grid-template-columns: 100% 100%;
    gap: 22px;
    margin-top: 20px;
}


.certificate-upload-box {
    width: 100%;
    border: 1px solid #F3F3F3;
    border-radius: 9px;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
    position: relative;
}

.certificate-upload-box input {
    width: 40px;
    opacity: 0;
    position: absolute;
    cursor: pointer;
}

.certificate-upload-box p {
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
    white-space: nowrap;
    margin: 0px;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
}

 p.check-path-text {
    font-style: italic;
    /* color: #0F0FD5; */
    color:  #1E90FF 
}


p.check-path-text:hover{
    color: #0F0FD5 
}

.upload-lable.active {
    background: #fff;
    position: absolute;
    top: -10px;
    width: auto;
    left: 15px;
    padding: 0px 5px;
}

.upload-icon-wrap img {
    width: 24px;
    cursor: pointer;
}

/***********  Edit Priofile Service css ***********/
.edit-profile-services-wrapper {
    width: 100%;
    /* height: 672px; */
    height: auto;
    border: 2px solid #F8F8F8;
    border-radius: 34px;
    padding: 30px 40px;
    margin-top: 30px;
    margin-bottom: 30px;
}


.edit-profile-services-wrapper h4 {
    font-size: 24px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.edit-profile-services-wrap{
    display: grid;
    /* grid-template-columns: auto auto; */
    grid-template-columns: 50% 50%;
    gap: 30px;
}


.edit-profile-service-head-left {
    display: flex;
    align-items: center;
    gap: 10px;
}


.edit-profile-service-head-left img{
    width: 70px;
}

.edit-profile-service-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
}

.edit-profile-service-head-right img {
    width: 29px;
    cursor: pointer;
}

.edit-profile-service-head-right img:hover{
    scale: 0.9;
}

.edit-profile-service-left {
    border: 1px solid #00A19B;
    padding: 15px 30px;
    border-radius: 9px;
    margin-top: 34px;
}

.edit-profile-service-head-left p {
    font-size: 18px;
    font-weight: 400;
    color: #1A1919;
    margin: 0px;
}

.commerical-services-wrap {
    border: 1px solid #F3F3F3;
    border-radius: 9px;
    padding: 16px 46px
}
  
  .commerical-services-wrap h4 {
    font-size: 18px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
    padding-bottom: 14px;
}

.commerical-specility-wrap{
    margin-top: 14px;
}

.special-services-wrapper{
    margin-bottom: 20px;
}

.special-services-wrapper p{
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px; 
}

.socail-insurance-number-input-wrap{
    margin-top: 160px;
    margin-bottom: 160px;
}


.bankdetail-image-wrapper{
    margin-bottom: 40px;
}

.bankdetail-image-wrapper img {
    width: 100%;
}

.signup-bankdetail-wrapper{
    margin-bottom: 20px;
}


.profile-commerical-services-select-wrap{
    display: grid;
    /* grid-template-columns: repeat(4, 1fr); */
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

.profile-commerical-services-select-wrap p, 
.profile-commerical-speciality-select-wrap p{
    font-size: 18px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px;
    width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

  
  .profile-commerical-speciality-select-wrap {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  

 
/***********  Edit Priofile Availbility css ***********/
.edit-profile-availabilty-wrapper {
    width: 100%;
    min-height: 333px;
    border: 2px solid #F8F8F8;
    border-radius: 34px;
    padding: 30px 40px;
    margin-top: 30px;
    margin-bottom: 30px;
}

.edit-profile-availabilty-header{
    display: flex;
    align-items: center;
    gap: 10px;
}

.edit-profile-availabilty-header h4 {
    font-size: 24px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.edit-profile-availabilty-header img{
    width: 24px;
    cursor: pointer;
}

.edit-profile-availabilty-header img:hover{
    scale: 0.9;
}
  
  .availability-slots-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px; 
    text-align: left; 
    margin-top: 30px;
  }
  
  .availability-day-slot-wrap{
    display: flex;
    align-items: baseline;
    font-size: 16px;
    color: #444;
 
  }
  
  .time-slot {
    font-size: 18px;
    font-weight: 400;
    margin-top: 0px;
    color: #1A1919;
}
  
  .additional-slot {
    margin-top: 10px; 
  }
  
  .availability-day-slot-wrap p {
    font-size: 18px;
    color: #1A1919;
    font-weight: 600;  
}

.availability-day-slot-wrap p span{
    margin-right: 16px;
    margin-left: 10px;
}
  
  .time-slot span {
    color: #626262; 
  }
  

/************ Edit Profile Testing css *******/
.edit-profile-testing-wrap {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    gap: 26px;
}

.edit-profile-repeat-wrap {
    height: 472px;
    border: 2px solid #F8F8F8;
    border-radius: 34px;
    padding: 35px 50px;
}

.edit-profile-repeat-wrap h4 {
    font-size: 24px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.contractor-testing-certificate-wrap {
    width: 100%;
    gap: 22px;
    margin-top: 20px;
}

.contractor-testing-certificate-wrap h5{
  font-size: 16px;
  color: #00A19B;
  font-weight: 600;
  margin: 0px; 
  padding-bottom: 20px; 
  padding-top: 20px;
}

.whmis-quiz-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.whmis-quiz-wrap p {
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
    margin: 0px;
}

.whmis-quiz-wrap h6 {
    font-size: 20px;
    color: #1A1919;
    font-weight: 500;
    margin: 0px;
}


.whmis-quiz-wrap h6 span{
    color: #00A19B;
}

.bank-detail-header-wrap{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.bank-detail-header-wrap .disable-twofa-input-wrap{
    display: flex;
}

.bank-check-approved-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
}

.bank-check-approved-wrap p{
    font-size: 14px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.crimnal-check-main-wrap{
    margin-top: 60px;
}

.interview-schedule-time-wrap{
    margin-top: 40px;
}



.schedule-main-wrapper {
    margin-top: 16px;
    position: sticky;
    bottom: 0px;
    width: 100%;
    background-color: #fff;
    z-index: 999;
}


.date-and-time-wrapper {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-top: 6px;
}

 .date-and-time-wrapper input {
    border: 1px solid #F3F3F3;
    border-radius: 9px;
    height: 62px;
    padding: 12px;
    width: 100%;
    font-size: 14px;
    color: #1A1919;
    font-weight: 500;
    outline: none;
    padding-left: 42px;
    padding-top: 24px;
}


.schedule-main-wrap .date-input-wrap {
    position: relative;
    width: 50%;
}

.date-input-wrap img {
    position: absolute;
    width: 35px;
    top: 10px;
    left: 4px;
    z-index: 99;
    cursor: pointer;
}


.custom-date-input p {
    position: absolute;
    left: 42px;
    top: 10px;
    font-size: 12px;
    color: #626262;
    font-weight: 400;
}

.custom-date-input input::placeholder{
    font-size: 14px;
    color: #1A1919;
    font-weight: 400;
}

.edit-profile-save-button{
    width: 33%;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 20px;
    padding-left: 50px;
}

.edit-profile-save-button button{
    height: 49px;
}

/***** Services Drawer css ***/

.commerical-services-select-wrap {
    display: grid;
    /* grid-template-columns: repeat(3, 1fr); */
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}


.commerical-speciality-select-wrap{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2px;
}

.accordion-item .accordion-header .accordion-button {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    padding: 10px 20px;
}

.accordion-button:not(.collapsed) {
    border-radius: 9px;
    border-bottom: none;
}

.accordion-button:not(.collapsed) {
    color: unset;
    background-color: unset;
    box-shadow: unset;
}

.accordion-button:not(.collapsed) {
    color: unset !important;
    background-color: unset !important;
    box-shadow: none !important;
}


.accordion-button:focus {
    box-shadow: none !important;
}

.profile-service-drawer-wrapper .accordion-button::after{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    border: none;
    width: 30px;
    height: 30px;
    object-fit: cover;
    background-size: 30px;
}


.profile-service-drawer-wrapper .accordion-button:not(.collapsed)::after{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    transform: rotate(180deg);
    width: 30px;
    height: 30px;
}

.accordion-item.active {
    border: 1px solid #00A19B;
}


.create-order-dropdwon .select-box-wrapper label {
    font-size: 26px;
    color: #383838;
    font-weight: 600;
    padding-left: 0px;
    margin: 0px;
    padding-bottom: 6px;
    margin-top: -10px;
}

p.link-path-style {
    /* color: #0F0FD5; */
    color:  #1E90FF;
    font-style: italic;
    cursor: pointer;
}

p.link-path-style:hover{
    color: #0F0FD5 
}

.contractor-application-status{
    margin-top: -40px;
}

.socail-sin-number-input{
    margin-top: 30px;
    width: 60%;
}

@media(max-width: 767px){
    .account-edit-profile-right {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .account-profile-info .username {
        margin-bottom: 30px;
        margin-top: 20px;
        text-align: center;
    }

    .create-order-dropdwon .select-box-wrapper label {
        font-size: 18px;
    }

    .profile-activity-wrapper h2 {
        font-size: 22px;
        font-weight: 600;
    }

    .invoice-status-wrapper h4 {
        font-size: 20px;
        color: #1A1919;
    }

    .contractor-application-status {
        margin-top: 20px;
    }

    .invoce-status-btn-wrap {
        width: 232px;
        height: 56px;
    }

    .invoce-status-btn-wrap p {
        font-size: 18px;
    }



    .edit-profile-address-wrap {
        grid-template-columns: 100%;
        gap: 18px;
    }

    .edit-profile-services-wrap {
        grid-template-columns: 100%;
        gap: 10px;
    }

    .edit-profile-testing-wrap {
        grid-template-columns: 100%;
    }

    .edit-profile-repeat-wrap {
        height: auto;
        border-radius: 16px;
        padding: 30px;
    }

    .profile-edit-application-dropdown .select-box-wrapper label {
        font-size: 18px;
    }

    .account-profile-head h3 {
        font-size: 26px;
    }

    .account-profile-head {
        align-items: center;
        gap: 14px;
    }

    .edit-profile-address-left h4 {
        font-size: 18px;
    }

    .edit-profile-main-left-wrap {
        padding: 30px;
        border-radius: 16px;
    }
        

    .edit-address-right p {
        font-size: 16px;
    }

    .edit-address-left p {
        font-size: 16px;
    }

    .edit-profile-address-left {
        width: 100%;
        min-height: auto;
        border-radius: 16px;
        padding: 30px;
    }

    .certificate-upload-box {
      width: 100%;
    }

    .availability-slots-grid {
        grid-template-columns: repeat(1, 1fr);
        gap: 30px;
    }

    .edit-profile-availabilty-header h4 {
        font-size: 18px;
    }

    .edit-profile-availabilty-wrapper {
        width: 100%;
        min-height: auto;
        border-radius: 16px;
        padding: 30px;
    }

    .edit-profile-repeat-wrap h4 {
        font-size: 18px;
    }

    .city-services-select-wrap {
        grid-template-columns: repeat(2, 1fr);
    } 

    .profile-commerical-services-select-wrap {
        grid-template-columns: repeat(1, 1fr);
    }

    .profile-commerical-speciality-select-wrap {
        grid-template-columns: repeat(1, 1fr);
    }

    .checkbox-container p {
        width: 100px;
    }

    .time-slot {
        font-size: 16px;
    }

    .availability-day-slot-wrap p {
        font-size: 18px;
    }

    .availability-day-slot-wrap p span {
        margin-right: 10px;
        margin-left: 6px;
    }

    .contractor-certificate-wrap {
        width: 100%;
        display: grid;
        grid-template-columns: 100%;
    }

    .edit-profile-services-wrapper h4 {
        font-size: 18px;
    }

    .edit-profile-services-wrapper {
        width: 100%;
        border-radius: 16px;
        padding: 30px
    }

    .edit-profile-service-head-left img {
        width: 60px;
    }

    .edit-profile-service-head-right img {
        width: 26px;
    }

    .commerical-services-wrap {
        border: 1px solid #F3F3F3;
        border-radius: 9px;
        padding: 16px 24px;
    }

    .edit-profile-service-left {
        padding: 14px 20px
    }

    .contractor-testing-certificate-wrap h5 {
        font-size: 14px;
        padding-bottom: 20px;
        padding-top: 10px;
    }

    .edit-profile-save-button {
        width: 100%;
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 20px;
        padding-bottom: 30px;
        padding-left: 0px;
    }

}


@media(max-width: 360px){
    .edit-profile-header-wrap {
        flex-direction: column;
    }

}

@media(min-width: 1599px) and (max-width: 1700px){
    .profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {
        font-size: 15px;
        width: 150px;
    }


    .city-services-select-wrap {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media(min-width: 1025px) and (max-width: 1599px){
    .profile-edit-application-dropdown .select-box-wrapper label {
        font-size: 20px;
        padding-left: 50px;
    }

    .inhouse-main-wrap p {
        font-size: 20px;
    }

    .edit-profile-address-left h4 {
        font-size: 18px;
    }

    .edit-address-left p {
        font-size: 16px;
    }

    .edit-address-right p {
        font-size: 16px;
    }

    .edit-profile-main-left-wrap {
        padding: 30px 30px;
    }

    .edit-profile-address-left {
        width: 100%;
        height: 450px;
        padding: 30px;
        overflow: auto;
        border-radius: 20px
    }

    .city-services-select-wrap {
        display: grid;
        /* grid-template-columns: repeat(3, 1fr); */
        grid-template-columns: repeat(2, 1fr);
    }

    .city-services-select-wrap .checkbox-container {
        padding-left: 30px;
        margin-bottom: 20px;
        white-space: unset;
    }

    .edit-profile-services-wrapper h4 {
        font-size: 20px;
    }

    .edit-profile-service-head-left img {
        width: 60px;
    }

    .edit-profile-service-head-right img {
        width: 26px;
    }

    .edit-profile-service-head-left p {
        font-size: 16px;
    }

    .edit-profile-services-wrapper h4 {
        font-size: 18px;
    }

    .edit-profile-service-left {
        padding: 15px 20px;
        /* height: 510px; */
        overflow: auto;
    }

    .commerical-services-wrap {
        padding: 16px 26px;
    }

    .profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {
        font-size: 15px;
    }

    .edit-profile-services-wrap {
        gap: 20px;
    }

    .edit-profile-services-wrapper {
        width: 100%;
        height: auto;
        padding: 20px 20px;
        border-radius: 20px;
    }

    .edit-profile-availabilty-header h4 {
        font-size: 18px;
    }

    .edit-profile-availabilty-header img {
        width: 20px;
    }

    .time-slot {
        font-size: 16px;
    }

    .edit-profile-repeat-wrap h4 {
        font-size: 16px;
    }

    .edit-profile-repeat-wrap {
        height: 430px;
        border: 2px solid #F8F8F8;
        border-radius: 20px;
        padding: 30px 20px;
    }

    .edit-profile-testing-wrap {
        gap: 20px;
        grid-template-columns: 32% 32% 32%;
    }

    .bank-check-approved-wrap p {
        font-size: 10px;
    }

    .contractor-testing-certificate-wrap h5 {
        font-size: 14px;
        padding-bottom: 10px;
        padding-top: 10px;
    }

    .date-and-time-wrapper {
        gap: 20px;
    }

    .time-input-wrap img {
        position: absolute;
        top: 8px;
    }

    .edit-profile-availabilty-wrapper {
        width: 100%;
        height: 300px;
        border: 2px solid #F8F8F8;
        border-radius: 20px;
        padding: 30px 30px;
        margin-top: 20px;
        margin-bottom: 20px;
        overflow: auto;
    }


    .edit-profile-save-button {
        width: 32%;
        margin-top: 30px;
        padding-left: 0px;
    }

    .edit-profile-testing-wrapper .date-and-time-wrapper {
        display: flex;
        flex-direction: column;
    }

    .edit-profile-testing-wrapper .schedule-main-wrap .date-input-wrap {
        width: 100%;
    }

    .edit-profile-testing-wrapper .time-input-wrap {
        width: 100%;
    }

    .edit-profile-testing-wrapper .time-input-wrap img {
        top: 12px;
    }

    .profile-edit-application-dropdown .react-dropdown-btn .selected-item p {
        font-size: 16px;
    }

    .profile-edit-application-dropdown .select-box-wrapper label {
        font-size: 20px;
        padding-left: 0px;
    }

    .account-detail-profile-wrap .account-edit-profile-right {
        display: flex;
        align-items: self-end;
        gap: 14px;
        margin-top: -70px;
    }

    .profile-edit-application-dropdown .select-box-wrapper {
        position: relative;
        text-align: center;
    }

    .service-drawer-main-wrap .accordion-item.active {
        border: 1px solid #00A19B;
        height: 450px;
        overflow: auto;
    }

    .profile-commerical-services-select-wrap p, 
    .profile-commerical-speciality-select-wrap p{
        width: 120px;
    }
}


@media (min-width: 767px) and (max-width: 1024px) {
    .edit-profile-address-wrap {
        grid-template-columns: 100%;
        gap: 18px;
    }

    .edit-profile-services-wrap {
        grid-template-columns: 100%;
        gap: 10px;
    }

    .edit-profile-testing-wrap {
        grid-template-columns: 100%;
    }

    .edit-profile-repeat-wrap {
        height: auto;
    }

    .profile-edit-application-dropdown .select-box-wrapper label {
        font-size: 20px;
    }

    .account-profile-head h3 {
        font-size: 26px;
    }

    .account-profile-head {
        align-items: center;
        gap: 14px;
    }

    .edit-profile-address-left h4 {
        font-size: 22px;
    }

    .edit-address-right p {
        font-size: 18px;
    }

    .edit-address-left p {
        font-size: 18px;
    }

    .edit-profile-address-left {
        width: 100%;
        min-height: auto;
    }

    .availability-slots-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 30px;
    }

    .edit-profile-availabilty-header h4 {
        font-size: 22px;
    }

    .edit-profile-availabilty-wrapper {
        width: 100%;
        min-height: auto;
    }

    .edit-profile-repeat-wrap h4 {
        font-size: 22px;
    }

    .city-services-select-wrap {
        grid-template-columns: repeat(3, 1fr);
    } 

    .profile-commerical-services-select-wrap {
        grid-template-columns: repeat(2, 1fr);
    }

    .checkbox-container p {
        width: 110px;
    }

    .time-slot {
        font-size: 16px;
    }

    .availability-day-slot-wrap p {
        font-size: 18px;
    }

    .availability-day-slot-wrap p span {
        margin-right: 10px;
        margin-left: 6px;
    }

}


@media (min-width: 1024px) and (max-width: 1199px) {
    .edit-profile-address-left h4 {
        font-size: 16px;
    }

    .edit-address-left p {
        font-size: 14px;
        font-weight: 400;
    }

    .edit-address-right p {
        font-size: 14px;
        text-align: right;
    }

    .contractor-certificate-wrap {
        width: 100%;
        display: grid;
        grid-template-columns: 100%;
        gap: 20px;
        margin-top: 20px;
    }

    .edit-profile-services-wrapper h4 {
        font-size: 16px;
    }

    .edit-profile-service-head-left img {
        width: 50px;
    }

    .profile-commerical-services-select-wrap {
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
    }

    .profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {
        font-size: 14px;
        width: 120px;
    }


    .edit-profile-service-left {
        padding: 15px 20px;
        height: 460px;
    }

    .edit-profile-services-wrapper {
        width: 100%;
        height: 570px;
    }

    .edit-profile-availabilty-header h4 {
        font-size: 16px;
    }

    .time-slot {
        font-size: 14px;
    }

    .availability-day-slot-wrap p {
        font-size: 16px;
    }

    .availability-day-slot-wrap p span {
        margin-right: 12px;
        margin-left: 8px;
    }

    .edit-profile-testing-wrap {
        gap: 20px;
        grid-template-columns: auto;
    }

    .edit-profile-repeat-wrap {
        height: auto;
    }

    .edit-profile-testing-wrapper .date-and-time-wrapper {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .edit-profile-save-button {
        width: 50%;
    }

    .account-detail-profile-wrap .account-edit-profile-right {
        display: flex;
        flex-direction: column;
    }

    .socail-sin-number-input {
        width: 100%;
    }

    .checkbox-container p {
        width: 140px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Dashboard/Account/editprofile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;;AAGA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;AAC3B;;CAEC;IACG,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;;AAGA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,mDAAmD;AACnD;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,8BAA8B;IAC9B,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;EAEE;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,2CAA2C;IAC3C,qCAAqC;IACrC,SAAS;AACb;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;;EAGE;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;;;AAIF,uDAAuD;AACvD;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;EAEE;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,WAAW;;EAEb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;EAEE;IACE,cAAc;EAChB;;;AAGF,8CAA8C;AAC9C;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;CAEC;IACG,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,2CAA2C;IAC3C,qCAAqC;IACrC,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;AAC/B;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yDAAoE;IACpE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;;AAGA;IACI,yDAAoE;IACpE,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;;;IAIA;QACI,2BAA2B;QAC3B,SAAS;IACb;;IAEA;QACI,2BAA2B;QAC3B,SAAS;IACb;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;MACE,WAAW;IACb;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,oBAAoB;QACpB,iBAAiB;IACrB;;AAEJ;;;AAGA;IACI;QACI,sBAAsB;IAC1B;;AAEJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;IAChB;;;IAGA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,aAAa;QACb,cAAc;QACd;IACJ;;IAEA;QACI,aAAa;QACb,2CAA2C;QAC3C,qCAAqC;IACzC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,kCAAkC;IACtC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,aAAa;QACb,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;IAClB;;;IAGA;QACI,UAAU;QACV,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,aAAa;QACb,cAAc;IAClB;;IAEA;;QAEI,YAAY;IAChB;AACJ;;;AAGA;IACI;QACI,2BAA2B;QAC3B,SAAS;IACb;;IAEA;QACI,2BAA2B;QAC3B,SAAS;IACb;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;AAEJ;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,2BAA2B;QAC3B,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;;IAGA;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,2BAA2B;IAC/B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".edit-profile-header-wrap {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-top: 20px;\n}\n\n.inhouse-main-wrap {\n    width: 233px;\n    height: 70px;\n    background: #F8F8F8;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n}\n\n.inhouse-main-wrap p{\n    font-size: 22px;\n    color: #00A19B;\n    font-weight: 400;\n    margin: 0px;\n}\n\n.account-edit-profile-right{\n    display: flex;\n    align-items: flex-end;\n    gap: 24px;\n}\n\n.profile-edit-application-dropdown .select-box-wrapper label {\n    font-size: 28px;\n    color: #1A1919;\n    font-weight: 600;\n    padding-left: 30px;\n    margin: 0px;\n    padding-bottom: 6px;\n}\n\n\n.profile-edit-application-dropdown .react-dropdown .react-dropdown-btn{\n    width: 233px;\n    height: 70px;\n}\n\n.profile-edit-application-dropdown .react-dropdown .dropdown-content {\n    width: 240px;\n}\n\n.profile-edit-application-dropdown .react-dropdown .dropdown-content .dropdown-item {\n    width: 220px;\n}\n\n\n.inhouse-main-wrapper .disable-twofa-input-wrap label {\n    cursor: pointer;\n    text-indent: -9999px;\n    width: 40px;\n    height: 20px;\n    background: #dff0f1;\n    \n    display: block;\n    border-radius: 100px;\n    position: relative;\n}\n\n.inhouse-main-wrapper .disable-twofa-input-wrap label:after {\n    content: '';\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    width: 14px;\n    height: 14px;\n    background: #BFBFBF;\n    border-radius: 90px;\n    transition: 0.3s;\n}\n\n\n.inhouse-main-wrapper .disable-twofa-input-wrap input:checked + label:after {\n    left: calc(100% - 4px);\n    transform: translateX(-100%);\n    background: #00A19B !important;\n}\n\n.inhouse-main-wrapper .disable-twofa-input-wrap {\n    margin-top: 6px;\n}\n\n.edit-profile-address-wrapper{\n    margin-top: 40px;\n}\n\n.edit-profile-address-wrap {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 50% 50%;\n    gap: 18px;\n}\n\n.edit-profile-address-left{\n    width: 100%;\n    min-height: 510px;\n    border: 2px solid #F8F8F8;\n    border-radius: 34px;\n    padding: 40px;\n}\n\n.edit-profile-main-left-wrap{\n    padding: 40px 55px;\n}\n\n\n.edit-profile-address-left h4 {\n    font-size: 24px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.edit-address-repeat {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 20px;\n}\n\n.edit-address-left p {\n    font-size: 20px;\n    color: #1A1919;\n    font-weight: 400;\n    margin: 0px;\n}\n\n.edit-address-right p {\n    font-size: 20px;\n    color: #626262;\n    font-weight: 500;\n    margin: 0px;\n}\n\n\n.city-services-select-wrap {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 10px;\n    margin-top: 30px;\n    margin-bottom: 10px;\n}\n\n.city-services-select-wrap .checkbox-container {\n    padding-left: 36px;\n    margin-bottom: 30px;\n    white-space: nowrap;\n}\n\n.city-services-select-wrap .checkbox-container .checkmark {\n    height: 22px;\n    width: 22px;\n}\n\n\n.contractor-certificate-wrap {\n    width: 50%;\n    display: grid;\n    grid-template-columns: 100% 100%;\n    gap: 22px;\n    margin-top: 20px;\n}\n\n\n.certificate-upload-box {\n    width: 100%;\n    border: 1px solid #F3F3F3;\n    border-radius: 9px;\n    height: 62px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 20px;\n    position: relative;\n}\n\n.certificate-upload-box input {\n    width: 40px;\n    opacity: 0;\n    position: absolute;\n    cursor: pointer;\n}\n\n.certificate-upload-box p {\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 400;\n    white-space: nowrap;\n    margin: 0px;\n    width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n p.check-path-text {\n    font-style: italic;\n    /* color: #0F0FD5; */\n    color:  #1E90FF \n}\n\n\np.check-path-text:hover{\n    color: #0F0FD5 \n}\n\n.upload-lable.active {\n    background: #fff;\n    position: absolute;\n    top: -10px;\n    width: auto;\n    left: 15px;\n    padding: 0px 5px;\n}\n\n.upload-icon-wrap img {\n    width: 24px;\n    cursor: pointer;\n}\n\n/***********  Edit Priofile Service css ***********/\n.edit-profile-services-wrapper {\n    width: 100%;\n    /* height: 672px; */\n    height: auto;\n    border: 2px solid #F8F8F8;\n    border-radius: 34px;\n    padding: 30px 40px;\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n\n.edit-profile-services-wrapper h4 {\n    font-size: 24px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.edit-profile-services-wrap{\n    display: grid;\n    /* grid-template-columns: auto auto; */\n    grid-template-columns: 50% 50%;\n    gap: 30px;\n}\n\n\n.edit-profile-service-head-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n\n.edit-profile-service-head-left img{\n    width: 70px;\n}\n\n.edit-profile-service-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 22px;\n}\n\n.edit-profile-service-head-right img {\n    width: 29px;\n    cursor: pointer;\n}\n\n.edit-profile-service-head-right img:hover{\n    scale: 0.9;\n}\n\n.edit-profile-service-left {\n    border: 1px solid #00A19B;\n    padding: 15px 30px;\n    border-radius: 9px;\n    margin-top: 34px;\n}\n\n.edit-profile-service-head-left p {\n    font-size: 18px;\n    font-weight: 400;\n    color: #1A1919;\n    margin: 0px;\n}\n\n.commerical-services-wrap {\n    border: 1px solid #F3F3F3;\n    border-radius: 9px;\n    padding: 16px 46px\n}\n  \n  .commerical-services-wrap h4 {\n    font-size: 18px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n    padding-bottom: 14px;\n}\n\n.commerical-specility-wrap{\n    margin-top: 14px;\n}\n\n.special-services-wrapper{\n    margin-bottom: 20px;\n}\n\n.special-services-wrapper p{\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 400;\n    margin: 0px; \n}\n\n.socail-insurance-number-input-wrap{\n    margin-top: 160px;\n    margin-bottom: 160px;\n}\n\n\n.bankdetail-image-wrapper{\n    margin-bottom: 40px;\n}\n\n.bankdetail-image-wrapper img {\n    width: 100%;\n}\n\n.signup-bankdetail-wrapper{\n    margin-bottom: 20px;\n}\n\n\n.profile-commerical-services-select-wrap{\n    display: grid;\n    /* grid-template-columns: repeat(4, 1fr); */\n    grid-template-columns: repeat(3, 1fr);\n    gap: 16px;\n}\n\n.profile-commerical-services-select-wrap p, \n.profile-commerical-speciality-select-wrap p{\n    font-size: 18px;\n    color: #1A1919;\n    font-weight: 400;\n    margin: 0px;\n    width: 170px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n  \n  .profile-commerical-speciality-select-wrap {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n  }\n  \n\n \n/***********  Edit Priofile Availbility css ***********/\n.edit-profile-availabilty-wrapper {\n    width: 100%;\n    min-height: 333px;\n    border: 2px solid #F8F8F8;\n    border-radius: 34px;\n    padding: 30px 40px;\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n.edit-profile-availabilty-header{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.edit-profile-availabilty-header h4 {\n    font-size: 24px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.edit-profile-availabilty-header img{\n    width: 24px;\n    cursor: pointer;\n}\n\n.edit-profile-availabilty-header img:hover{\n    scale: 0.9;\n}\n  \n  .availability-slots-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 30px; \n    text-align: left; \n    margin-top: 30px;\n  }\n  \n  .availability-day-slot-wrap{\n    display: flex;\n    align-items: baseline;\n    font-size: 16px;\n    color: #444;\n \n  }\n  \n  .time-slot {\n    font-size: 18px;\n    font-weight: 400;\n    margin-top: 0px;\n    color: #1A1919;\n}\n  \n  .additional-slot {\n    margin-top: 10px; \n  }\n  \n  .availability-day-slot-wrap p {\n    font-size: 18px;\n    color: #1A1919;\n    font-weight: 600;  \n}\n\n.availability-day-slot-wrap p span{\n    margin-right: 16px;\n    margin-left: 10px;\n}\n  \n  .time-slot span {\n    color: #626262; \n  }\n  \n\n/************ Edit Profile Testing css *******/\n.edit-profile-testing-wrap {\n    display: grid;\n    grid-template-columns: 33% 33% 33%;\n    gap: 26px;\n}\n\n.edit-profile-repeat-wrap {\n    height: 472px;\n    border: 2px solid #F8F8F8;\n    border-radius: 34px;\n    padding: 35px 50px;\n}\n\n.edit-profile-repeat-wrap h4 {\n    font-size: 24px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.contractor-testing-certificate-wrap {\n    width: 100%;\n    gap: 22px;\n    margin-top: 20px;\n}\n\n.contractor-testing-certificate-wrap h5{\n  font-size: 16px;\n  color: #00A19B;\n  font-weight: 600;\n  margin: 0px; \n  padding-bottom: 20px; \n  padding-top: 20px;\n}\n\n.whmis-quiz-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.whmis-quiz-wrap p {\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 400;\n    margin: 0px;\n}\n\n.whmis-quiz-wrap h6 {\n    font-size: 20px;\n    color: #1A1919;\n    font-weight: 500;\n    margin: 0px;\n}\n\n\n.whmis-quiz-wrap h6 span{\n    color: #00A19B;\n}\n\n.bank-detail-header-wrap{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.bank-detail-header-wrap .disable-twofa-input-wrap{\n    display: flex;\n}\n\n.bank-check-approved-wrap {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.bank-check-approved-wrap p{\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.crimnal-check-main-wrap{\n    margin-top: 60px;\n}\n\n.interview-schedule-time-wrap{\n    margin-top: 40px;\n}\n\n\n\n.schedule-main-wrapper {\n    margin-top: 16px;\n    position: sticky;\n    bottom: 0px;\n    width: 100%;\n    background-color: #fff;\n    z-index: 999;\n}\n\n\n.date-and-time-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-top: 6px;\n}\n\n .date-and-time-wrapper input {\n    border: 1px solid #F3F3F3;\n    border-radius: 9px;\n    height: 62px;\n    padding: 12px;\n    width: 100%;\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 500;\n    outline: none;\n    padding-left: 42px;\n    padding-top: 24px;\n}\n\n\n.schedule-main-wrap .date-input-wrap {\n    position: relative;\n    width: 50%;\n}\n\n.date-input-wrap img {\n    position: absolute;\n    width: 35px;\n    top: 10px;\n    left: 4px;\n    z-index: 99;\n    cursor: pointer;\n}\n\n\n.custom-date-input p {\n    position: absolute;\n    left: 42px;\n    top: 10px;\n    font-size: 12px;\n    color: #626262;\n    font-weight: 400;\n}\n\n.custom-date-input input::placeholder{\n    font-size: 14px;\n    color: #1A1919;\n    font-weight: 400;\n}\n\n.edit-profile-save-button{\n    width: 33%;\n    margin: 0 auto;\n    margin-top: 40px;\n    margin-bottom: 20px;\n    padding-left: 50px;\n}\n\n.edit-profile-save-button button{\n    height: 49px;\n}\n\n/***** Services Drawer css ***/\n\n.commerical-services-select-wrap {\n    display: grid;\n    /* grid-template-columns: repeat(3, 1fr); */\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n}\n\n\n.commerical-speciality-select-wrap{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 2px;\n}\n\n.accordion-item .accordion-header .accordion-button {\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n    padding: 10px 20px;\n}\n\n.accordion-button:not(.collapsed) {\n    border-radius: 9px;\n    border-bottom: none;\n}\n\n.accordion-button:not(.collapsed) {\n    color: unset;\n    background-color: unset;\n    box-shadow: unset;\n}\n\n.accordion-button:not(.collapsed) {\n    color: unset !important;\n    background-color: unset !important;\n    box-shadow: none !important;\n}\n\n\n.accordion-button:focus {\n    box-shadow: none !important;\n}\n\n.profile-service-drawer-wrapper .accordion-button::after{\n    background-image: url(\"../../../public/images/icons/flip-arrow.png\");\n    border: none;\n    width: 30px;\n    height: 30px;\n    object-fit: cover;\n    background-size: 30px;\n}\n\n\n.profile-service-drawer-wrapper .accordion-button:not(.collapsed)::after{\n    background-image: url(\"../../../public/images/icons/flip-arrow.png\");\n    transform: rotate(180deg);\n    width: 30px;\n    height: 30px;\n}\n\n.accordion-item.active {\n    border: 1px solid #00A19B;\n}\n\n\n.create-order-dropdwon .select-box-wrapper label {\n    font-size: 26px;\n    color: #383838;\n    font-weight: 600;\n    padding-left: 0px;\n    margin: 0px;\n    padding-bottom: 6px;\n    margin-top: -10px;\n}\n\np.link-path-style {\n    /* color: #0F0FD5; */\n    color:  #1E90FF;\n    font-style: italic;\n    cursor: pointer;\n}\n\np.link-path-style:hover{\n    color: #0F0FD5 \n}\n\n.contractor-application-status{\n    margin-top: -40px;\n}\n\n.socail-sin-number-input{\n    margin-top: 30px;\n    width: 60%;\n}\n\n@media(max-width: 767px){\n    .account-edit-profile-right {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .account-profile-info .username {\n        margin-bottom: 30px;\n        margin-top: 20px;\n        text-align: center;\n    }\n\n    .create-order-dropdwon .select-box-wrapper label {\n        font-size: 18px;\n    }\n\n    .profile-activity-wrapper h2 {\n        font-size: 22px;\n        font-weight: 600;\n    }\n\n    .invoice-status-wrapper h4 {\n        font-size: 20px;\n        color: #1A1919;\n    }\n\n    .contractor-application-status {\n        margin-top: 20px;\n    }\n\n    .invoce-status-btn-wrap {\n        width: 232px;\n        height: 56px;\n    }\n\n    .invoce-status-btn-wrap p {\n        font-size: 18px;\n    }\n\n\n\n    .edit-profile-address-wrap {\n        grid-template-columns: 100%;\n        gap: 18px;\n    }\n\n    .edit-profile-services-wrap {\n        grid-template-columns: 100%;\n        gap: 10px;\n    }\n\n    .edit-profile-testing-wrap {\n        grid-template-columns: 100%;\n    }\n\n    .edit-profile-repeat-wrap {\n        height: auto;\n        border-radius: 16px;\n        padding: 30px;\n    }\n\n    .profile-edit-application-dropdown .select-box-wrapper label {\n        font-size: 18px;\n    }\n\n    .account-profile-head h3 {\n        font-size: 26px;\n    }\n\n    .account-profile-head {\n        align-items: center;\n        gap: 14px;\n    }\n\n    .edit-profile-address-left h4 {\n        font-size: 18px;\n    }\n\n    .edit-profile-main-left-wrap {\n        padding: 30px;\n        border-radius: 16px;\n    }\n        \n\n    .edit-address-right p {\n        font-size: 16px;\n    }\n\n    .edit-address-left p {\n        font-size: 16px;\n    }\n\n    .edit-profile-address-left {\n        width: 100%;\n        min-height: auto;\n        border-radius: 16px;\n        padding: 30px;\n    }\n\n    .certificate-upload-box {\n      width: 100%;\n    }\n\n    .availability-slots-grid {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 30px;\n    }\n\n    .edit-profile-availabilty-header h4 {\n        font-size: 18px;\n    }\n\n    .edit-profile-availabilty-wrapper {\n        width: 100%;\n        min-height: auto;\n        border-radius: 16px;\n        padding: 30px;\n    }\n\n    .edit-profile-repeat-wrap h4 {\n        font-size: 18px;\n    }\n\n    .city-services-select-wrap {\n        grid-template-columns: repeat(2, 1fr);\n    } \n\n    .profile-commerical-services-select-wrap {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .profile-commerical-speciality-select-wrap {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .checkbox-container p {\n        width: 100px;\n    }\n\n    .time-slot {\n        font-size: 16px;\n    }\n\n    .availability-day-slot-wrap p {\n        font-size: 18px;\n    }\n\n    .availability-day-slot-wrap p span {\n        margin-right: 10px;\n        margin-left: 6px;\n    }\n\n    .contractor-certificate-wrap {\n        width: 100%;\n        display: grid;\n        grid-template-columns: 100%;\n    }\n\n    .edit-profile-services-wrapper h4 {\n        font-size: 18px;\n    }\n\n    .edit-profile-services-wrapper {\n        width: 100%;\n        border-radius: 16px;\n        padding: 30px\n    }\n\n    .edit-profile-service-head-left img {\n        width: 60px;\n    }\n\n    .edit-profile-service-head-right img {\n        width: 26px;\n    }\n\n    .commerical-services-wrap {\n        border: 1px solid #F3F3F3;\n        border-radius: 9px;\n        padding: 16px 24px;\n    }\n\n    .edit-profile-service-left {\n        padding: 14px 20px\n    }\n\n    .contractor-testing-certificate-wrap h5 {\n        font-size: 14px;\n        padding-bottom: 20px;\n        padding-top: 10px;\n    }\n\n    .edit-profile-save-button {\n        width: 100%;\n        margin: 0 auto;\n        margin-top: 30px;\n        margin-bottom: 20px;\n        padding-bottom: 30px;\n        padding-left: 0px;\n    }\n\n}\n\n\n@media(max-width: 360px){\n    .edit-profile-header-wrap {\n        flex-direction: column;\n    }\n\n}\n\n@media(min-width: 1599px) and (max-width: 1700px){\n    .profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {\n        font-size: 15px;\n        width: 150px;\n    }\n\n\n    .city-services-select-wrap {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media(min-width: 1025px) and (max-width: 1599px){\n    .profile-edit-application-dropdown .select-box-wrapper label {\n        font-size: 20px;\n        padding-left: 50px;\n    }\n\n    .inhouse-main-wrap p {\n        font-size: 20px;\n    }\n\n    .edit-profile-address-left h4 {\n        font-size: 18px;\n    }\n\n    .edit-address-left p {\n        font-size: 16px;\n    }\n\n    .edit-address-right p {\n        font-size: 16px;\n    }\n\n    .edit-profile-main-left-wrap {\n        padding: 30px 30px;\n    }\n\n    .edit-profile-address-left {\n        width: 100%;\n        height: 450px;\n        padding: 30px;\n        overflow: auto;\n        border-radius: 20px\n    }\n\n    .city-services-select-wrap {\n        display: grid;\n        /* grid-template-columns: repeat(3, 1fr); */\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .city-services-select-wrap .checkbox-container {\n        padding-left: 30px;\n        margin-bottom: 20px;\n        white-space: unset;\n    }\n\n    .edit-profile-services-wrapper h4 {\n        font-size: 20px;\n    }\n\n    .edit-profile-service-head-left img {\n        width: 60px;\n    }\n\n    .edit-profile-service-head-right img {\n        width: 26px;\n    }\n\n    .edit-profile-service-head-left p {\n        font-size: 16px;\n    }\n\n    .edit-profile-services-wrapper h4 {\n        font-size: 18px;\n    }\n\n    .edit-profile-service-left {\n        padding: 15px 20px;\n        /* height: 510px; */\n        overflow: auto;\n    }\n\n    .commerical-services-wrap {\n        padding: 16px 26px;\n    }\n\n    .profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {\n        font-size: 15px;\n    }\n\n    .edit-profile-services-wrap {\n        gap: 20px;\n    }\n\n    .edit-profile-services-wrapper {\n        width: 100%;\n        height: auto;\n        padding: 20px 20px;\n        border-radius: 20px;\n    }\n\n    .edit-profile-availabilty-header h4 {\n        font-size: 18px;\n    }\n\n    .edit-profile-availabilty-header img {\n        width: 20px;\n    }\n\n    .time-slot {\n        font-size: 16px;\n    }\n\n    .edit-profile-repeat-wrap h4 {\n        font-size: 16px;\n    }\n\n    .edit-profile-repeat-wrap {\n        height: 430px;\n        border: 2px solid #F8F8F8;\n        border-radius: 20px;\n        padding: 30px 20px;\n    }\n\n    .edit-profile-testing-wrap {\n        gap: 20px;\n        grid-template-columns: 32% 32% 32%;\n    }\n\n    .bank-check-approved-wrap p {\n        font-size: 10px;\n    }\n\n    .contractor-testing-certificate-wrap h5 {\n        font-size: 14px;\n        padding-bottom: 10px;\n        padding-top: 10px;\n    }\n\n    .date-and-time-wrapper {\n        gap: 20px;\n    }\n\n    .time-input-wrap img {\n        position: absolute;\n        top: 8px;\n    }\n\n    .edit-profile-availabilty-wrapper {\n        width: 100%;\n        height: 300px;\n        border: 2px solid #F8F8F8;\n        border-radius: 20px;\n        padding: 30px 30px;\n        margin-top: 20px;\n        margin-bottom: 20px;\n        overflow: auto;\n    }\n\n\n    .edit-profile-save-button {\n        width: 32%;\n        margin-top: 30px;\n        padding-left: 0px;\n    }\n\n    .edit-profile-testing-wrapper .date-and-time-wrapper {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .edit-profile-testing-wrapper .schedule-main-wrap .date-input-wrap {\n        width: 100%;\n    }\n\n    .edit-profile-testing-wrapper .time-input-wrap {\n        width: 100%;\n    }\n\n    .edit-profile-testing-wrapper .time-input-wrap img {\n        top: 12px;\n    }\n\n    .profile-edit-application-dropdown .react-dropdown-btn .selected-item p {\n        font-size: 16px;\n    }\n\n    .profile-edit-application-dropdown .select-box-wrapper label {\n        font-size: 20px;\n        padding-left: 0px;\n    }\n\n    .account-detail-profile-wrap .account-edit-profile-right {\n        display: flex;\n        align-items: self-end;\n        gap: 14px;\n        margin-top: -70px;\n    }\n\n    .profile-edit-application-dropdown .select-box-wrapper {\n        position: relative;\n        text-align: center;\n    }\n\n    .service-drawer-main-wrap .accordion-item.active {\n        border: 1px solid #00A19B;\n        height: 450px;\n        overflow: auto;\n    }\n\n    .profile-commerical-services-select-wrap p, \n    .profile-commerical-speciality-select-wrap p{\n        width: 120px;\n    }\n}\n\n\n@media (min-width: 767px) and (max-width: 1024px) {\n    .edit-profile-address-wrap {\n        grid-template-columns: 100%;\n        gap: 18px;\n    }\n\n    .edit-profile-services-wrap {\n        grid-template-columns: 100%;\n        gap: 10px;\n    }\n\n    .edit-profile-testing-wrap {\n        grid-template-columns: 100%;\n    }\n\n    .edit-profile-repeat-wrap {\n        height: auto;\n    }\n\n    .profile-edit-application-dropdown .select-box-wrapper label {\n        font-size: 20px;\n    }\n\n    .account-profile-head h3 {\n        font-size: 26px;\n    }\n\n    .account-profile-head {\n        align-items: center;\n        gap: 14px;\n    }\n\n    .edit-profile-address-left h4 {\n        font-size: 22px;\n    }\n\n    .edit-address-right p {\n        font-size: 18px;\n    }\n\n    .edit-address-left p {\n        font-size: 18px;\n    }\n\n    .edit-profile-address-left {\n        width: 100%;\n        min-height: auto;\n    }\n\n    .availability-slots-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 30px;\n    }\n\n    .edit-profile-availabilty-header h4 {\n        font-size: 22px;\n    }\n\n    .edit-profile-availabilty-wrapper {\n        width: 100%;\n        min-height: auto;\n    }\n\n    .edit-profile-repeat-wrap h4 {\n        font-size: 22px;\n    }\n\n    .city-services-select-wrap {\n        grid-template-columns: repeat(3, 1fr);\n    } \n\n    .profile-commerical-services-select-wrap {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .checkbox-container p {\n        width: 110px;\n    }\n\n    .time-slot {\n        font-size: 16px;\n    }\n\n    .availability-day-slot-wrap p {\n        font-size: 18px;\n    }\n\n    .availability-day-slot-wrap p span {\n        margin-right: 10px;\n        margin-left: 6px;\n    }\n\n}\n\n\n@media (min-width: 1024px) and (max-width: 1199px) {\n    .edit-profile-address-left h4 {\n        font-size: 16px;\n    }\n\n    .edit-address-left p {\n        font-size: 14px;\n        font-weight: 400;\n    }\n\n    .edit-address-right p {\n        font-size: 14px;\n        text-align: right;\n    }\n\n    .contractor-certificate-wrap {\n        width: 100%;\n        display: grid;\n        grid-template-columns: 100%;\n        gap: 20px;\n        margin-top: 20px;\n    }\n\n    .edit-profile-services-wrapper h4 {\n        font-size: 16px;\n    }\n\n    .edit-profile-service-head-left img {\n        width: 50px;\n    }\n\n    .profile-commerical-services-select-wrap {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 16px;\n    }\n\n    .profile-commerical-services-select-wrap p, .profile-commerical-speciality-select-wrap p {\n        font-size: 14px;\n        width: 120px;\n    }\n\n\n    .edit-profile-service-left {\n        padding: 15px 20px;\n        height: 460px;\n    }\n\n    .edit-profile-services-wrapper {\n        width: 100%;\n        height: 570px;\n    }\n\n    .edit-profile-availabilty-header h4 {\n        font-size: 16px;\n    }\n\n    .time-slot {\n        font-size: 14px;\n    }\n\n    .availability-day-slot-wrap p {\n        font-size: 16px;\n    }\n\n    .availability-day-slot-wrap p span {\n        margin-right: 12px;\n        margin-left: 8px;\n    }\n\n    .edit-profile-testing-wrap {\n        gap: 20px;\n        grid-template-columns: auto;\n    }\n\n    .edit-profile-repeat-wrap {\n        height: auto;\n    }\n\n    .edit-profile-testing-wrapper .date-and-time-wrapper {\n        display: flex;\n        flex-direction: row;\n        gap: 20px;\n    }\n\n    .edit-profile-save-button {\n        width: 50%;\n    }\n\n    .account-detail-profile-wrap .account-edit-profile-right {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .socail-sin-number-input {\n        width: 100%;\n    }\n\n    .checkbox-container p {\n        width: 140px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
